import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Send, MessageCircle, CheckCircle } from 'lucide-react';
import { getLandingData, trackEvent } from '@/lib/api';

export default function RedirectPage() {
  const { type } = useParams();
  const [countdown, setCountdown] = useState(2);

  useEffect(() => {
    bounceVisitor();
  }, [type]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const bounceVisitor = async () => {
    try {
      const res = await getLandingData();
      const manager = res.data?.manager;
      const settings = res.data?.settings;

      // Track the lead event
      await trackEvent({
        event_type: 'lead',
        manager_id: manager?.id,
        page_url: window.location.href,
        utm_source: new URLSearchParams(window.location.search).get('utm_source') || '',
        utm_medium: new URLSearchParams(window.location.search).get('utm_medium') || '',
        utm_campaign: new URLSearchParams(window.location.search).get('utm_campaign') || '',
        referrer: document.referrer || ''
      });

      // Redirect after delay
      setTimeout(() => {
        let link = '';
        if (type === 'telegram') {
          link = manager?.telegram_link || settings?.default_telegram || '';
        } else if (type === 'whatsapp') {
          link = manager?.whatsapp_link || settings?.default_whatsapp || '';
        }

        if (link) {
          window.location.href = link;
        } else {
          window.location.href = '/';
        }
      }, 2000);
    } catch (err) {
      console.error('Redirect error:', err);
      window.location.href = '/';
    }
  };

  const isTelegram = type === 'telegram';

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="redirect-page">
      <div className="max-w-md w-full text-center">
        <div className={`w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center ${isTelegram ? 'bg-sky-100' : 'bg-green-100'}`}>
          {isTelegram ? (
            <Send className="w-10 h-10 text-sky-500" />
          ) : (
            <MessageCircle className="w-10 h-10 text-green-500" />
          )}
        </div>

        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Отлично!
        </h1>
        <p className="text-slate-600 mb-6">
          Сейчас переведём вас в {isTelegram ? 'Telegram' : 'WhatsApp'}
        </p>

        <div className="flex items-center justify-center gap-2 text-slate-500 mb-8">
          <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center animate-pulse">
            <span className="text-sm font-medium">{countdown}</span>
          </div>
          <span className="text-sm">Перенаправление...</span>
        </div>

        <div className="flex items-center justify-center gap-2 text-green-600">
          <CheckCircle className="w-5 h-5" />
          <span className="text-sm">Ваша заявка зарегистрирована</span>
        </div>
      </div>
    </div>
  );
}
